export const modalActionsSx = {
  justifyContent: 'flex-end',
  '& .btn-area': {
    display: 'flex',
    flexDirection: 'row-reverse',
    gap: 1,
  },
};
